import { useEffect, useState } from 'react';

// Returns a periodically-updated `now` timestamp (ms) so components that show a
// live countdown recompute over time without a page reload (deadline-reminder
// brief §5). Also re-syncs when the tab regains focus/visibility, catching a
// page that sat backgrounded while a browser throttled its timers.
//
// Default cadence is 60s — enough for an hours/minutes countdown; pass a
// smaller interval only where seconds matter.
export function useNow(intervalMs = 60_000) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const tick = () => setNow(Date.now());
    const id = setInterval(tick, intervalMs);
    const onVisible = () => { if (!document.hidden) tick(); };
    window.addEventListener('focus', tick);
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      clearInterval(id);
      window.removeEventListener('focus', tick);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [intervalMs]);
  return now;
}
